import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "search",
  "use": "search-usage",
  "viewBox": "0 0 20 19",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 19\" id=\"search\">\n    <g fill=\"none\" fill-rule=\"evenodd\" stroke=\"#222\" stroke-width=\"3\" opacity=\".99\" transform=\"translate(2 2)\">\n        <ellipse cx=\"6.084\" cy=\"5.982\" rx=\"6.084\" ry=\"5.982\" />\n        <path d=\"M10.65 10.33l5.653 5.653\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol